import React, { useContext, useEffect, useState } from 'react';
import { InputNumber } from "../../inputNumber/InputNumber.js";
import { InputUnit } from "../../inputUnit/InputUnit.js";
import { SliderContext } from "../providers/SliderProvider.js";
import styles from "./SliderValueLabel.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function SliderValueLabel({
  index,
  value,
  elevation,
  format,
  onValueChange,
  onLabelActive
}) {
  const [labelEle, setLabelEle] = useState(null);
  const [input, setInput] = useState(value);
  const [focus, setFocus] = useState(false);
  const {
    calcCSSPosition,
    calcLabelOffset
  } = useContext(SliderContext);
  useEffect(() => {
    setInput(value);
  }, [value]);
  useEffect(() => {
    if (focus) {
      onLabelActive(index);
    }
  }, [onLabelActive, focus, index]);
  const inputProps = {
    className: styles.labelInput,
    label: '',
    value: focus ? input : value,
    format: {
      ...(format === 'unformattedNumber' && {
        thousandSeparator: false
      }),
      onValueChange: ({
        floatValue
      }) => {
        if (floatValue) {
          setInput(floatValue); // onValueChange(index, floatValue);
        }
      }
    },
    onFocus: () => setFocus(true),
    onBlur: () => {
      onValueChange(index, input, false);
      setFocus(false);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsx("div", {
      ref: setLabelEle,
      className: styles.label,
      style: {
        left: calcCSSPosition(value, calcLabelOffset(value, labelEle)),
        zIndex: elevation
      },
      children: format === 'number' || format === 'unformattedNumber' ? /*#__PURE__*/_jsx(InputNumber, {
        ...inputProps
      }) : /*#__PURE__*/_jsx(InputUnit, {
        ...inputProps,
        suffix: format
      })
    })
  });
}